export const getScanTypeLabel = (scanType?: string | null) => {
  if (!scanType) return '-';
  if (scanType === 'scan') return 'Сканирование';
  if (scanType.startsWith('manual')) return 'Ручной';
  return scanType;
};
